module.exports = __webpack_public_path__ + "img/_Lew.4434f1d2.png";